module.exports = __webpack_public_path__ + "img/benefit-icon_percentage.2860e246.svg";